import * as i0 from '@angular/core';
import * as i1 from './buttons.module';
import * as i2 from './button-checkbox.directive';
import * as i3 from './button-radio.directive';
import * as i4 from './button-radio-group.directive';
export const ButtonsModuleNgFactory:i0.NgModuleFactory<i1.ButtonsModule> = (null as any);
var _decl0_0:i2.ButtonCheckboxDirective = (<any>(null as any));
var _decl0_1:i3.ButtonRadioDirective = (<any>(null as any));
var _decl0_2:i4.ButtonRadioGroupDirective = (<any>(null as any));
var _decl0_3:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_4:i0.ElementRef<any> = (<any>(null as any));
